import script from "./TheNews.vue?vue&type=script&setup=true&lang=js"
export * from "./TheNews.vue?vue&type=script&setup=true&lang=js"

import "./TheNews.vue?vue&type=style&index=0&id=c628d736&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.40_vue@3.5.40_webpack@5.109.0_clean-css@5.3.3_c_eab102a9d91ac3d44b724d4105ef1f5b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c628d736"]])

export default __exports__